import { isEmpty } from 'lodash-es'

import { intToBool } from '../../utils'

export const getPollState = (poll) => {
  if (intToBool(poll.open_p)) {
    return 'finish'
  }

  if (intToBool(poll.display_results_p)) {
    return 'unpublish'
  }

  if (!isEmpty(poll.opened_date)) {
    return 'publish'
  }

  return 'start'
}

export const pollStateParamMap = {
  start: { open_p: 1 },
  finish: { open_p: 0 },
  publish: { display_results_p: 1 },
  unpublish: { display_results_p: 0 },
}
